/* =================== SLIDE HOME =================== */
$(function () {
  $(".carousel-slide").each(function () {
    // Elemento
    const $slide = $(this);

    // Total de itens no carrossel
    const totalItens = $slide.find(".splide__slide").length;

    // Intervalo
    let slideInterval = $slide.data("slide-interval") || 10000;

    // Opções gerais do slide
    let slideOpts = {
      type: "loop",
      perPage: 1,
      perMove: 1,
      speed: 1000,
      autoplay: true,
      interval: slideInterval,
      pauseOnHover: true,
      arrows: false,
      pagination: true,
      lazyLoad: "nearby",
      breakpoints: {
        // Mobile
        768: {
          arrows: false,
        },
      },
    };

    // Habilite o auto height (Altura automática com base em cada slide)
    if ($slide.hasClass("carousel-autoheight")) {
      slideOpts.autoHeight = true;
      slideOpts.updateOnMove = true;
    }

    // Exibe barra de progresso
    const showProgress = $slide.data("slide-progress");
    if (showProgress) {
      $slide.append(
        `<div class="splide__progress"><div class="splide__progress__bar"></div></div>`
      );
    }

    // Ajusta para quando houver apenas um item no carrossel
    if (totalItens === 1) {
      slideOpts.type = "slide";
      slideOpts.arrows = false;
      slideOpts.pagination = false;
      slideOpts.drag = false;
      slideOpts.autoplay = false;
      slideOpts.keyboard = false;
    }

    // Inicia o slide
    let slide = new Splide($slide[0], slideOpts);

    // Configuração das animações
    function applyAnimationsSlide(index) {
      document.querySelectorAll("[data-slide-animation]").forEach((el) => {
        el.style.opacity = "0";
        el.classList.remove(el.dataset.slideAnimation);
      });
      let nextSlide = slide.Components.Elements.slides[index];
      if (nextSlide) {
        nextSlide.querySelectorAll("[data-slide-animation]").forEach((el) => {
          let customDelay = parseInt(el.dataset.slideAnimationDelay) || 0;
          let finalDelay = 500 + customDelay;
          setTimeout(() => {
            el.style.opacity = "1";
            el.classList.add(el.dataset.slideAnimation);
          }, finalDelay);
        });
      }
    }
    // Aplica a animação sempre que mudar de slide
    slide.on("move", (newIndex) => {
      applyAnimationsSlide(newIndex);
    });
    // Aplica a animação no primeiro slide ao carregar
    slide.on("mounted", () => applyAnimationsSlide(0));

    // Monta o slide
    slide.mount();
  });
});
